import { render } from "./ThePagination.vue?vue&type=template&id=c641461a"
import script from "./ThePagination.vue?vue&type=script&lang=js"
export * from "./ThePagination.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__